module.exports = __webpack_public_path__ + "media/customize/banner-popup-c75d886f.svg";